// extracted by mini-css-extract-plugin
export default {"displayByIdTextField":"DisplayById_displayByIdTextField__biGJw","idPage":"DisplayById_idPage__jUnQJ"};